import React from 'react';

const Spinner = () => {
    return <i className="fa fa-spinner fa-2x fa-spin d-inline-block"/>
}

export default Spinner;